<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid>
        <v-row
            class="flex-child"
        >
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-container fluid>
                        <v-row align="center">
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-select
                                    @change="pageChange"
                                    :items="classItems"
                                    :label="$vuetify.lang.t('$vuetify.custom.exam.className')"
                                    hide-details
                                    solo
                                    v-model="searchData.classId"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-text-field
                                    solo
                                    hide-details
                                    :label="$vuetify.lang.t('$vuetify.custom.exam.examName')"
                                    v-model="searchData.examName"
                                />
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <ETDatePicker v-model="searchData.examTime"
                                              :label="$vuetify.lang.t('$vuetify.custom.exam.examTime')"></ETDatePicker>
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="3">
                                <v-select
                                    @change="pageChange"
                                    :items="examTypeItems"
                                    :label="$vuetify.lang.t('$vuetify.custom.exam.examType')"
                                    hide-details
                                    solo
                                    v-model="searchData.examType"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="12" sm="3" xs="3">
                                <v-row justify="end">
                                    <v-btn v-5="permissionCode.search" color="primary mr-3" @click="pageChange" dark large>
                                        <v-icon left>mdi-magnify</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.searchBtn') }}
                                    </v-btn>
                                    <v-btn v-5="permissionCode.add" color="success mr-3" @click="dialog=true" dark large>
                                        <v-icon left>mdi-plus</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.exam.add') }}
                                    </v-btn>
                                    <v-btn v-5="permissionCode.export" color="success mr-3" @click="exportDialog=true" dark large>
                                        <v-icon left>mdi-export</v-icon>
                                        {{ $vuetify.lang.t('$vuetify.custom.exam.export') }}
                                    </v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
            </v-col>
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="desserts"
                        item-key="name"
                        class="elevation-1"
                        multi-sort
                        :loading="loading"
                        :footer-props="footerProps"
                        :loading-text="loadingText"
                        :options.sync="options"
                        :server-items-length="totalDesserts"
                        @update:options="changeOptions"

                    >
                        <template v-slot:item.examType="{ item }">
                            {{ item.examType==0?"面试":"笔试"}}
                        </template>
                        <template v-slot:item.type="{ item }">
                            {{ item.type==0?"周考":"月考"}}
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn v-5="permissionCode.update" color="normal" x-small @click="updateItem(item)" class="ml-2">
                                <v-icon small>
                                    mdi-update
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.exam.update') }}
                            </v-btn>
                            <v-btn v-5="permissionCode.import" color="normal" x-small class="ml-2" @click="importExcel(item)">
                                <v-icon small>
                                    mdi-import
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.exam.import') }}
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-sheet>
            </v-col>
            <v-dialog v-model="dialog" persistent max-width="700px">
                <exam-add v-model="dialog" @initialize="pageChange"></exam-add>
            </v-dialog>
        </v-row>
        <input v-show="false" type="file" ref="uploadFileRef" @change="uploadFile"></input>
        <v-dialog
            v-model="exportDialog"
            max-width="500px"
            persistent
        >
            <v-card>
                <v-card-title>
                    选择导出班级
                </v-card-title>
                <v-card-text>
                    <v-select
                        v-model="selectValue"
                        :items="selectItems"
                        label="选择班级"
                        hide-details
                    ></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error" dark
                        @click="exportDialog = false"
                    >
                        取消
                    </v-btn>
                    <v-btn
                        color="success" dark @click="exportExam"
                    >
                        导出
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="examDialog" max-width="700px">
            <exam-update v-model="examDialog" @initialize="pageChange" :examMsg="examMsg"></exam-update>
        </v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>
<style></style>
<script>
    import Mock from 'mockjs';
    import ETDatePicker from '@/components/datepicker/ETDatePicker'
    import examAdd from './exam-add'
    import examUpdate from './exam-update'

    export default {
        data() {
            return {
                permissionCode:{
                    search:'biz:exam:search',
                    add:'biz:exam:add',
                    export:'biz:exam:export',
                    update:'biz:exam:update',
                    import:'biz:exam:import',
                },
                examMsg: {},
                examDialog: false,
                overlay: false,
                selectItems: [
                    {text: "选择班级", value: ''},
                ],
                classObj: {},
                exportDialog: false,
                selectValue: '',
                rules: [v => !!v || '文件必选'],
                uploadIsLoading: false,
                fileInfo: '',
                dialog: false,
                loading: true,
                loadingText: this.$vuetify.lang.t('$vuetify.custom.dataLoading'),
                selected: [],
                footerProps: {
                    showFirstLastPage: true,
                    showCurrentPage: true,
                    itemsPerPageOptions:[5,10,20,50],
                    //disableItemsPerPage:true,
                },
                searchData: {
                    classId: '',
                    examName: '',
                    examTime: [],
                    startDate: '',
                    endDate: '',
                    examType: ''
                },
                options: {},
                headers: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.exam.className'), value: 'className',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.exam.examName'), value: 'examName',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.exam.examTime'), value: 'examTime',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.exam.examType'), value: 'examType',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.exam.type'), value: 'type',
                    },
                    {text: this.$vuetify.lang.t('$vuetify.custom.actions'), value: 'actions', sortable: false},
                ],
                totalDesserts: 0,
                desserts: [],
                examTypeItems: [
                    {text: "选择考试类型", value: ''},
                    {text: '笔试', value: '1'},
                    {text: '面试', value: '0'},
                ],
                classItems: [
                    {text: "选择班级", value: ''},
                ],
                currItem: {},
            }

        },
        mounted() {
            this.initClassItems()
        },
        methods: {
            pageChange(){
                this.options.page = 1
                this.initialize()
            },
            updateItem(item) {
                this.examMsg = Object.assign({}, {
                    id: item.id,
                    examName: item.examName,
                    examTime: item.examTime,
                    examType: item.examType,
                    type: item.type//考试周期类型
                })
                this.examDialog = true
            },
            exportExam() {
                if (this.selectValue) {
                    this.exportDialog = false
                    this.$api.achievement.exportTemplate({classId: this.selectValue}).then(data => {
                        const content = data
                        const blob = new Blob([content])
                        const fileName = this.classObj[this.selectValue] + '.xls'
                        this.selectValue = ''
                        if ('download' in document.createElement('a')) { // 非IE下载
                            const elink = document.createElement('a')
                            elink.download = fileName
                            elink.style.display = 'none'
                            elink.href = URL.createObjectURL(blob)
                            document.body.appendChild(elink)
                            elink.click()
                            URL.revokeObjectURL(elink.href) // 释放URL 对象
                            document.body.removeChild(elink)
                        } else { // IE10+下载
                            navigator.msSaveBlob(blob, fileName)
                        }
                    })
                } else {
                    this.$dialog.alert("请选择班级")
                }
            },
            download(data) {
                if (!data) {
                    return
                }
                let url = window.URL.createObjectURL(new Blob([data]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', 'excel.')
                document.body.appendChild(link)
                link.click()
            },
            initClassItems() {
                this.$api.classList.getAllClass({
                    params: {
                        type: '0'
                    }
                }).then(data => {
                    if (data.data) {
                        data.data.forEach(obj => {
                            this.classItems.push({text: obj.className, value: obj.id})
                            this.selectItems.push({text: obj.className, value: obj.id})
                            this.classObj[obj.id] = obj.className
                        })
                    }
                })
            },
            importExcel(item) {
                this.$refs.uploadFileRef.dispatchEvent(new MouseEvent('click'))
                this.currItem = item
            },
            async uploadFile(e) {
                let file = e.target.files[0]
                if (!(file.name.endsWith(".xls") || file.name.endsWith(".xlsx"))) {
                    this.$dialog.alert("请上传excel文件")
                    return
                }
                this.overlay = true
                let form = new FormData();
                form.append("filePath", "achievement");
                form.append('file', file);
                let files = await this.$file.fileUpload(form)
                this.$api.achievement.importScore({fileId: files.fileId, examId: this.currItem.id}).then(data => {
                    this.overlay = false
                    if (data.flag) {
                        this.$dialog.alert("导入成功")
                    } else {
                        let errmsg = ''
                        data.data.forEach(val => {
                            if (val.nameError != null || val.scoreError != null) {
                                errmsg = errmsg + "第" + val.row + "行" + (val.nameError == null ? "" : val.nameError) + (val.scoreError == null ? "" : val.scoreError) + '<br/>'

                            }


                        })
                        this.$dialog.alert(errmsg)
                    }
                })
            },
            initialize() {
                this.searchData.startDate = ''
                this.searchData.endDate = ''
                if (this.searchData.examTime.length > 0) {
                    if (this.searchData.examTime.length == 1) {
                        this.searchData.startDate = this.searchData.examTime[0]
                    } else {
                        this.searchData.startDate = this.searchData.examTime[0]
                        this.searchData.endDate = this.searchData.examTime[1]
                    }
                }
                this.loading = true
                this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
                this.$api.exam.selectExam(
                    Object.assign({}, this.searchData, this.options)
                ).then(data => {
                    this.loading = false;
                    if (data.data) {
                        this.desserts = data.data;
                        this.totalDesserts = data.total;
                    } else {
                        this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                    }

                })
                // let data = Mock.mock({
                //     'data|10': [
                //         {
                //             'className': '@cname',
                //             'examName': '@cname',
                //             'examTime': new Date().toISOString().substr(0, 10),
                //             'examType': "周考"
                //         }
                //     ]
                // });
                // this.desserts = data.data
                // this.totalDesserts = 10;

            },
            changeOptions(option) {
                this.initialize()
            }
        },
        components: {
            ETDatePicker, examAdd, examUpdate
        },
    }
</script>
